var _g, _path, _g2, _path2, _g3, _path3, _path4, _g4, _path5, _path6, _g5, _path7, _g6, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 84,
    viewBox: "0 0 64 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_174_576)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.2036,
    cy: 50.3264,
    r: 27.6939,
    fill: "url(#paint0_linear_174_576)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_174_576)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_174_576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 55,
    width: 27,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4366 56.8625L28.1494 71.8671C28.5625 71.6211 28.7853 71.0775 28.6902 70.3052L54.9773 55.3005C55.075 56.068 54.8521 56.6264 54.4366 56.8625Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_174_576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6877 70.312L54.9749 55.3074C55.0725 56.0797 54.8497 56.6332 54.4341 56.8693L28.147 71.8739C28.5601 71.628 28.7829 71.0844 28.6877 70.312Z",
    fill: "#CC995C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_174_576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 2,
    width: 33,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8501 2.30225C40.8501 4.85303 43.5765 8.47136 46.9538 10.3875L20.6666 25.3921C17.2869 23.476 14.5555 19.8576 14.563 17.3069L40.8501 2.30225Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_174_576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5605 17.3137L40.8477 2.30908C40.8477 4.85987 43.574 8.47819 46.9513 10.3944C47.9433 10.9932 49.052 11.3812 50.2059 11.5332L23.9188 26.5378C22.7697 26.3866 21.6659 25.9994 20.6792 25.4014C17.2994 23.4853 14.5681 19.8669 14.5756 17.3162L14.5605 17.3137Z",
    fill: "#9D7547"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9038 26.5359L50.1935 11.5239L54.9777 55.3005L28.6881 70.3125L23.9038 26.5359Z",
    fill: "#CC995C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_174_576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 10,
    width: 31,
    height: 17
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9538 10.3875C47.9457 10.9863 49.0544 11.3743 50.2084 11.5263L23.9212 26.5309C22.7722 26.3797 21.6684 25.9925 20.6816 25.3945L46.9538 10.3875Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_174_576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5605 17.3142L40.8477 2.30957C40.8477 4.86035 43.574 8.47868 46.9513 10.3948C47.9433 10.9937 49.052 11.3817 50.2059 11.5337L23.9188 26.5383C22.7697 26.387 21.6659 25.9998 20.6792 25.4019C17.2994 23.4858 14.5681 19.8674 14.5756 17.3166L14.5605 17.3142Z",
    fill: "#9D7547"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5603 17.3142C14.5603 19.865 17.2841 23.4833 20.6639 25.3995C21.6507 25.9974 22.7544 26.3846 23.9035 26.5359L28.6877 70.3198C28.8655 71.7416 27.9567 72.4205 26.7725 71.749L10.9302 62.7511C9.74848 62.0821 8.8472 60.3774 9.02996 59.1599L14.5603 17.3142Z",
    fill: "#A16E3D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_174_576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 32,
    height: 17
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5796 15.3465L41.8667 0.341841C42.9658 -0.285401 44.8459 -0.0418838 46.979 1.16832L20.6918 16.1729C18.5563 14.9627 16.6887 14.7192 15.5796 15.3465Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_174_576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5796 15.3465L41.8667 0.341841C42.9658 -0.285401 44.8459 -0.0418838 46.979 1.16832L20.6918 16.1729C18.5588 14.9627 16.6862 14.7192 15.5821 15.3465H15.5796Z",
    fill: "#DCB07B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_174_576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 1,
    width: 34,
    height: 26
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0657 11.2115L25.7785 26.2161C26.4194 25.8496 26.795 25.1879 26.7975 24.2483C26.7975 21.7 24.0711 18.0841 20.6938 16.1679L46.981 1.16333C50.3583 3.07949 53.0921 6.69782 53.0846 9.24368C53.0821 10.1833 52.7066 10.845 52.0657 11.2115Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_174_576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6938 16.1726L46.981 1.16797C50.3583 3.08413 53.0921 6.70246 53.0846 9.24832C53.0846 10.1904 52.7066 10.8521 52.0657 11.2161L25.7785 26.2208C26.4194 25.8542 26.795 25.1926 26.7975 24.2529C26.7975 21.7046 24.0711 18.0887 20.6938 16.1726Z",
    fill: "#DCB07B"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6941 16.1728C24.0714 18.0889 26.8052 21.7048 26.7977 24.2531C26.7977 25.9061 25.6386 26.7129 23.9086 26.5358C22.7596 26.3845 21.6558 25.9973 20.6691 25.3994C17.2893 23.4832 14.5579 19.8649 14.5654 17.3141C14.573 14.7633 17.3118 14.2517 20.6941 16.1728Z",
    fill: "#946538"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0868 40.1235C49.539 33.4909 46.8414 27.2952 42.0616 26.285C37.2819 25.2748 32.2299 29.8326 30.7778 36.4652C29.3256 43.0978 32.0232 49.2935 36.803 50.3038C41.5827 51.314 46.6347 46.7561 48.0868 40.1235Z",
    fill: "#FFCE45"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9847 43.5872C36.6868 41.0192 35.0971 27.2421 35.0119 26.5017C34.9168 25.6826 34.2459 27.9529 34.0731 29.8248C34.0731 29.8248 33.6776 37.4034 34.7516 40.4314C35.0695 41.3243 35.1822 40.8274 35.375 41.3439C35.6351 42.0591 35.85 42.7894 36.0184 43.5307L35.9257 43.5602L35.7154 45.2599L36.5541 52.531L37.3352 52.868L37.9261 52.4351L38.2791 51.3724L37.4203 43.9341L36.9847 43.5872Z",
    fill: "#FFFEF4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2574 39.5876L43.8869 39.1891C43.8168 38.7242 42.9055 32.5772 42.9055 31.5638C42.9055 31.4777 42.9055 31.3449 42.8805 31.1924C43.281 30.3905 43.594 29.1286 43.7918 28.5924C43.8518 27.1756 43.0006 22.4602 42.7903 21.3188L42.4148 21.5451L43.226 27.3059L42.7603 27.6478L41.9542 21.8452C41.7814 21.9608 41.7414 21.9879 41.5711 22.1109L42.2646 28.1349L42.1319 28.2333C42.0618 28.1373 42.0218 28.1472 42.0343 28.3071C42.0117 28.157 41.9742 28.2038 41.9366 28.3809L41.8014 28.4792L41.108 22.4528C40.9377 22.5807 40.8726 22.6348 40.7049 22.7701L41.2807 28.74L40.815 29.0844L40.2518 23.1514C40.1291 23.2547 40.0014 23.3605 39.8862 23.4687C39.9563 24.7133 40.2668 29.8518 40.6523 30.9562C40.9552 31.1481 41.4384 31.7876 41.9316 31.9131C41.944 32.0247 41.9624 32.1355 41.9867 32.2452C42.202 33.0987 42.7378 39.531 42.7753 40.0107L42.56 40.9085L43.3987 48.1796L44.1798 48.519L44.7706 48.0836L45.1236 47.021L44.2574 39.5876Z",
    fill: "#FFFEF4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4108 59.1798C41.3134 59.1783 41.2173 59.1575 41.1282 59.1186C41.0392 59.0797 40.959 59.0236 40.8926 58.9535C40.7352 58.7867 40.6142 58.59 40.5371 58.3754C40.3218 58.5083 40.084 58.646 39.8211 58.7911L39.4556 58.1516C39.796 57.9647 40.0865 57.7925 40.3343 57.6301C40.2694 57.2291 40.2559 56.8217 40.2942 56.4175C40.3794 55.5516 40.7399 54.3635 41.4759 53.8593C41.6293 53.7502 41.8058 53.6766 41.9923 53.6443C42.1788 53.6119 42.3703 53.6215 42.5524 53.6724C42.6512 53.6978 42.7423 53.7462 42.8181 53.8134C42.8939 53.8806 42.9522 53.9646 42.9881 54.0585C43.291 54.7842 42.5149 56.3338 42.2896 56.7077C42.0041 57.1864 41.6245 57.6045 41.173 57.9376C41.214 58.1193 41.3 58.2883 41.4233 58.4296C41.6562 58.373 42.1168 57.881 42.3171 57.667C42.9034 57.0197 43.3088 56.2341 43.4938 55.3868L44.2273 55.5221C44.0195 56.5052 43.5504 57.4166 42.8679 58.1639C42.3822 58.6829 41.9416 59.1158 41.4759 59.165L41.4108 59.1798ZM42.212 54.3611C42.1 54.3627 41.9914 54.3988 41.9015 54.4644C41.4334 54.7817 41.1129 55.7238 41.0378 56.4863C41.0217 56.6902 41.0217 56.895 41.0378 57.0988C41.2805 56.8754 41.4888 56.6186 41.6562 56.3363C42.0818 55.6254 42.3822 54.6415 42.3196 54.3685L42.212 54.3611Z",
    fill: "#4A5059"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2974 56.2698C44.1351 56.2699 43.9777 56.2152 43.8517 56.1148C43.5563 55.8688 43.3961 55.399 43.351 54.6512C43.3159 53.7224 43.4939 52.7976 43.8718 51.9455C44.1123 51.4417 44.4527 50.9901 44.8732 50.6172C45.0384 50.4462 45.2452 50.3192 45.474 50.2482C45.474 50.1966 45.474 50.1449 45.474 50.0933L46.2251 50.1154V50.4204C46.2401 50.9296 46.2576 51.5273 46.2126 52.1693C46.228 52.3673 46.2539 52.5643 46.2902 52.7597C46.3197 52.9426 46.3649 53.1228 46.4254 53.2983C46.8489 53.0052 47.1802 52.6013 47.3817 52.1324L48.0677 52.4202C47.7648 53.1139 47.0888 53.9305 46.5205 54.0412C46.4238 54.0634 46.323 54.0616 46.2273 54.0358C46.1315 54.01 46.0439 53.9611 45.9722 53.8936C45.8483 54.4758 45.6321 55.0353 45.3313 55.5515C45.2404 55.7267 45.1133 55.8812 44.9581 56.0054C44.8029 56.1295 44.6231 56.2204 44.43 56.2722C44.3858 56.2743 44.3415 56.2735 44.2974 56.2698ZM45.449 51.0919L45.3939 51.1436C45.0442 51.4532 44.7615 51.8288 44.5627 52.248C44.2334 52.9953 44.0786 53.8055 44.1096 54.6192C44.1371 55.2366 44.2623 55.4949 44.3249 55.5441C44.4736 55.4412 44.5968 55.3067 44.6854 55.1506C44.9933 54.6586 45.2412 53.8764 45.4039 52.8654C45.4415 52.6195 45.4665 52.3932 45.484 52.1644C45.4565 51.8151 45.4465 51.4461 45.449 51.0919Z",
    fill: "#4A5059"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9375 52.4941C47.8268 52.4935 47.7197 52.4553 47.6345 52.3858C47.4956 52.2483 47.4075 52.0691 47.3842 51.8767C46.9882 49.9746 46.811 48.0347 46.8559 46.0938H47.607C47.5641 47.9432 47.7278 49.7917 48.0952 51.6061C48.6015 51.0842 49.0062 50.4756 49.2894 49.8105L49.9703 50.1106C49.5372 51.06 48.9864 51.8447 48.4682 52.2653C48.3251 52.4019 48.1366 52.4831 47.9375 52.4941Z",
    fill: "#4A5059"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6983 49.4045L46.1074 48.9519C46.9161 47.9311 47.7347 46.9644 48.5434 46.074L49.1016 46.5659C48.303 47.4416 47.4944 48.396 46.6983 49.4045Z",
    fill: "#4A5059"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9304 62.7514L26.7778 71.7418C27.5288 72.1649 28.1597 72.0518 28.4827 71.5549L28.693 70.325L25.128 62.4119L15.582 57.0767L9.03019 59.1724C8.84243 60.3777 9.74371 62.0823 10.9304 62.7514Z",
    fill: "#A16E3D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0957 59.5905L19.0918 26.3294L17.9126 23.3457L23.9036 26.536L28.7079 69.7616L28.6878 70.3126L20.0957 59.5905Z",
    fill: "#946538"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_174_576",
    x: 0.509766,
    y: 19.6326,
    width: 63.3877,
    height: 63.3877,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_174_576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_174_576",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_174_576",
    x1: 17.1526,
    y1: 26.8469,
    x2: 43.0404,
    y2: 73.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D05600"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 72,
    fill: "white",
    transform: "translate(9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.d64311ac3f871ebf3b01b88ac0f9d4be.svg";
export { ForwardRef as ReactComponent };